// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"a95b7a4b","453":"8d7ab114"}[chunkId] + ".chunk.js";
};